import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useFloating, offset, flip, shift, autoUpdate, useDismiss, useFocus, useHover, useRole, useInteractions, FloatingPortal } from '@floating-ui/react';
import { useState } from 'react';
import { navItemTooltipContainer } from '../NavigationBarItem/navigation-bar-item-styles.js';
import { useNavigationContext } from '../NavigationContext/NavigationContext.js';
import { NavigationBarItem } from '../NavigationBarItem/NavigationBarItem.js';
import { zIndexes } from '../constants.js';

const NavigationBarLink = ({ as, activeIcon, bold, inactiveIcon, label, isActive = false, ...props }) => {
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);
    const { context, floatingStyles, refs } = useFloating({
        middleware: [
            offset(20),
            flip({
                fallbackAxisSideDirection: "start",
            }),
            shift(),
        ],
        open: isTooltipOpen,
        onOpenChange: setIsTooltipOpen,
        placement: "right",
        whileElementsMounted: autoUpdate,
    });
    const { isExpanded } = useNavigationContext();
    const dismiss = useDismiss(context);
    const focus = useFocus(context, { enabled: true });
    const hover = useHover(context, { move: false });
    const role = useRole(context, { role: "tooltip" });
    // Merge all the interactions into prop getters
    const { getReferenceProps, getFloatingProps } = useInteractions([
        hover,
        focus,
        dismiss,
        role,
    ]);
    return (jsxs(Fragment, { children: [jsx(NavigationBarItem, { "aria-current": isActive, as: as || "a", bold: bold, icon: isActive ? activeIcon : inactiveIcon, isActive: isActive, isExpanded: isExpanded, label: label, ref: refs.setReference, ...props, ...getReferenceProps() }), isTooltipOpen && !isExpanded && (jsx(FloatingPortal, { children: jsx("div", { className: navItemTooltipContainer(), ref: refs.setFloating, style: { ...floatingStyles, zIndex: zIndexes.navigationPopover }, ...getFloatingProps(), children: label }) }))] }));
};

export { NavigationBarLink };
